import React from 'react';
import NavBar from '../shared/NavBar';
import SiteFooter from '../shared/SiteFooter';

const NotFound = () => {
    return (
        <>
            <NavBar />
            <p>We can't find the page you are looking for. Please try again.</p>
            <SiteFooter />
        </>
    )
};

export default NotFound;



